import React, { useContext, useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { AuthContext } from '../../Auth/AuthContext'

/**
 * Parameters
 *
 * reportFilter: active de second mode that show a filter dates and a button to download reports
 * reportFilterHandleButton: Function that will be executed to download report
 * reportFilterHandleButtonText: Text that show on reportFilterHandleButton
 * handleChangeDates: Function that change dates values, it will send two values ->
 *                    1) Inputs value
 *                    2) Inputs type (The name of a field that will be saved using hook)
 */

export const ContentHeader = ({
  title = 'Title',
  breadcrumb = 'Inicio',
  windowTitle = 'Window Title',

  /**Variables to display a report filter */
  reportFilter = false,
  reportFilterHandleButton = () => {},
  reportFilterHandleButtonText = 'Descargar reporte',
  handleChangeDates = () => {},

  /**Variables to display a date filter */
  dateFilter = false,
  dateFilterHandleChangeDates = () => {},
  breadcrumbContent = false,
  titleContent = null,
  extraContent = null,
  addNewButton = false,
  addNewButtonNoPermission = false,
  addNewButtonOnClick = () => {},
  addNewButtonText = 'Agregar nuevo',
}) => {
  const _title = JSON.parse(localStorage.getItem('configSys'))
  const { user } = useContext(AuthContext)
  const location = useLocation()
  const [buttonsPermissions, setButtonsPermissions] = useState({
    create: false,
  })

  useEffect(() => {
    document.title = `${_title?.project_name} | ${windowTitle}`
  }, [title, windowTitle, _title?.project_name])

  //EFFECTS:
  useEffect(() => {
    const permissions = user?.userPermissions
    const findPermission = permissions.find(
      (item) => item?.module_info?.relative_link === location.pathname
    )
    setButtonsPermissions({
      create: {
        show: findPermission?.access_retrieve || false,
        relative_link: findPermission?.module_info?.relative_link,
      }
    })
  }, [location.pathname, user])

  return (
    <section className="content-header">
      <div className="container-fluid">
        <div className="row mb-2 d-flex align-items-center">
          {(addNewButton && (buttonsPermissions?.create?.show || addNewButtonNoPermission)) ? (
            <>
              <div className="row p-0">
                <div className="col-12 d-flex align-items-center justify-content-between p-0">
                  <h1 className="header-title">{title || ''}</h1>
                  {addNewButtonNoPermission ? (
                    <button 
                      className='btn btn-purple btn-sm' 
                      onClick={addNewButtonOnClick}
                    >
                      {addNewButtonText}
                    </button>
                  ):(
                    <Link
                      className="btn btn-purple btn-sm"
                      to={`${buttonsPermissions?.create?.relative_link}/new`}
                    >
                      {addNewButtonText}
                    </Link>
                  )}
                </div>
              </div>
            </>
          ) : (
            <>
              {title !== '' && (
                <div className="col-sm-6">
                  <h1 className="header-title">{title}</h1>
                </div>
              )}

              {title === '' && titleContent && <>{titleContent}</>}
            </>
          )}

          {reportFilter ? (
            <>
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <div>
                      <label className="title-filter" htmlFor="dateStart">
                        Desde:&nbsp;
                      </label>
                      <input
                        id="dateStart"
                        onChange={(e) => handleChangeDates(e, 'start')}
                        className="inputDateColorado"
                        type="date"
                      />
                      <label className="title-filter" htmlFor="dateEnd">
                        &nbsp;Hasta:&nbsp;
                      </label>
                      <input
                        id="dateEnd"
                        onChange={(e) => handleChangeDates(e, 'end')}
                        className="inputDateColorado mr-3"
                        type="date"
                      />
                    </div>
                  </li>
                  <li>
                    <button
                      className="btn purple btn-sm"
                      onClick={reportFilterHandleButton}
                    >
                      {reportFilterHandleButtonText}
                    </button>
                  </li>
                </ol>
              </div>
            </>
          ) : dateFilter ? (
            <>
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
                <ol className="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <div>
                      <label className="title-filter" htmlFor="dateStart">
                        Desde:&nbsp;
                      </label>
                      <input
                        id="dateStart"
                        onChange={(e) =>
                          dateFilterHandleChangeDates(e, 'start')
                        }
                        className="inputDateColorado"
                        type="date"
                      />
                      <label className="title-filter" htmlFor="dateEnd">
                        &nbsp;Hasta:&nbsp;
                      </label>
                      <input
                        id="dateEnd"
                        onChange={(e) => dateFilterHandleChangeDates(e, 'end')}
                        className="inputDateColorado mr-3"
                        type="date"
                      />
                    </div>
                  </li>
                </ol>
              </div>
            </>
          ) : (
            <>
              {breadcrumb !== '' && (
                <>
                  {!breadcrumbContent ? (
                    <div className="col-sm-6">
                      <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item">
                          <Link to="/dashboard">Panel</Link>
                        </li>
                        <li className="breadcrumb-item active">{breadcrumb}</li>
                      </ol>
                    </div>
                  ) : (
                    <>{breadcrumbContent}</>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
      {extraContent}
    </section>
  )
}

export default ContentHeader
